module.exports = __webpack_public_path__ + "static/media/details-30-image-1.07e2e475.jpg";